import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}
/*  font-family: 'Poppins', sans-serif; */
const GlobalStyle = createGlobalStyle`
  * {
   
	font-family: 'Kanit', sans-serif;
  }
  body {
	    background-color: rgb(222 237 232) !important;

	img {
	  height: auto;
	  max-width: 100%;
	}
  }

  .eggpRq{background-color:rgb(213 229 221) !important;}
  .eyEdtT{background-color: rgb(243 240 236) !important;}
  .cJPoRF{color:rgb(0, 169, 78) !important;}
  .cgCIZW{color:rgb(0, 169, 78) !important;}
  .dHcCPL{background-color: rgb(2, 175, 80) !important;}


	.czgfEA{background-color: rgb(243 239 231);}
	.kBuQmo{border-bottom: 1px solid rgb(217 206 190);}
	.bgDmob {background: rgb(217 209 197);}
	.lnNwgg{    background-color: #00a94e;}
	.hvRFEz{color:#cca566;}
	.gQcoem{color:#00a94e;}
	.kMoOAO{fill:#00a94e;}
	.eMQvev{background-color: rgb(0 0 0);}
	.hkHScR{border: 1px solid rgb(209 184 144);}
	.jkWTQH{border-bottom: 1px solid rgb(209 184 144);}
	.cqaHWI{background-color: rgb(237 232 224);    border: 1px solid rgb(18, 170, 99);    color: rgb(0 0 0);}
	.bZscAo{background-color: rgb(247 237 220);     border: 1px solid rgb(18, 170, 99);}

	.kwWtdy{ color:#fff;}
	
  
	.iVOmes{color:#000;}
	.dSaNby svg{fill:#000;}
	.giuPYt svg{fill:#000;}
	.hzwwoO{fill:#000;}
	.fRQJEU{color:#000;}
	.fAwZeF{fill:#000;}
	.hQbuhK{color:#333;}
	.dZYBiL{color: #00a94e;}
	.kPLVRr{color:rgba(0, 0, 0, 1);}
	.iWuxMg{color: #00a94e;}
	.bxsbHj{fill: #00a94e;}
	.dXsmrP{color: #00a94e;}
	.dSaNby:hover{background-color: rgb(243 241 236);}
	.jCNweI:hover {background-color: rgb(245, 241, 218);}
	.bNcJuH{background-color: rgb(243 241 236);}
	.gbgKgp {color:#ae9879;}
	.dDlBur {color:#836236;}
	.supplymain .iWuxMg{color: #000;}

	.ckbFvZ{color:#fff;}
	.bWAMUn svg{fill:#fff;}
	.zumaL{fill:#fff;}
	.kspKPF{color:#fff;}
	.hqUFIa{fill:#00a94e;}
	.iqmSnt{color:#fff;}
	.jnA-Dsk{color:#fff;}
	.giettx:hover{background-color:#00a94e;}
	.kRokrL{background-color: #00a94e;}
	.Xujss{background-color: #00a94e;}
	.fFQa-dQ{background-color: #00a94e;}
	.gSqloL{background-color: #00a94e;}
	.gYPJde{background: rgb(255 255 255) !important;}
	.eTWWEz{background: linear-gradient(111.68deg, rgb(255 255 255) 0%, rgb(255 255 255) 100%) !important;}
	.knhxhB{background:#000;}
	.htvoSB{background: rgb(36 36 36);}
	.dNDYoS{background: rgb(36 36 36);}
	.bnGMHn .gqcxan{fill: rgb(149 149 149) !important;}
	.gvCrHQ .iloNdM {fill:rgb(255 255 255);}
	
	
	
	
	

	   .fBNttr{color: #00a94e !important;}
	   .eKidLY{ padding:0px !important;}
	   .cqAoBB{background-color:#000!important;}
	   .daipcm  .gdIPrC{top:0px!important;}
	   .cqAoBB {top: -1px !important;}
	   .fxmQLQ {top: -1px !important;}
	   .fpNzxn{top: -0px !important;}
	   .ehqnWq{ background:#231F20 !important;padding: 0px 0px !important;}
	   .fAeRFD svg{fill:#231F20 !important;}
	   .bkja-Dq{background:#231F20!important;}
	   .fabmCt svg {fill:#231F20!important;}
	   .fVeYNf svg{fill: #212429 !important;}
	   .bkja-Dq{padding: 25px 0px !important;}
	   .iOxPMv {color: #fff !important;}
	   .QYyfx{border: 1px solid ##00a94e !important;  background: #202930 !important; color: ##00a94e !important;}
	   .dtMzoV{background-color: #424448 !important;}
	   .fsNcbF{ display:none !important;}
	   .box1 .jKRLxB span{ color: rgb(0, 151, 225)!important;}
	   .jKRLxB span{ color:#fff !important;}
	   .dOaoYk {color:rgb(255 255 255)!important; font-size: 15px !important; font-weight: 500!important;}
	   .eNPaSS {fill:#fff!important;}
	   .gxjbeC{ background:#302e2f!important;}
	   .TbFrM{background:#231F20!important;}
	   .bpRBhS{border-bottom:#3c3c3c !important;}
	   .gRrcRp {background:#383637!important;}
	   .fJpWgJ {color:#bac3f3!important;}
	   .cEaVth {background-color:#464646!important;}
	   .cRXrDg {color:#fff !important;}
	   .kzpBYq{background-color:#202930 !important; border:2px solid ##00a94e !important; color:##00a94e !important;}
	   .gQiTC{background-color: #232323!important; border: 2px solid #d3b560 !important;border-radius: 50px; }
	   .cKJfLV{color:##00a94e !important;}
	   .jZAWNq{background-color: rgb(102 102 102) !important;}
	   .gymbJT {background-color: rgb(52 52 52) !important;}
	   .cHwlTP{color: #ababab !important;}
	   .jKRLxB {color: #ffffff !important;}

	   .fBLOOp {fill: #0bf !important;}
	   .iERSLm{background-color:#00a94e !important;  color:#fff !important;}
	   .gXaxaI {background-color:#646464!important;}
	   .gXaxaI .RVVfa {color: rgb(227 227 227) !important;background: none !important;}
	   .AuSzL {color:#fff !important;}
	   .cJFSgv {border-top:1px solid rgb(66 66 66)!important;}
	   .hWZoXO{ background:##00a94e !important;}
	   .kgrNUM{ color:##00a94e !important;}
	   .bvpMkj{background-color: rgb(76 76 76) !important;}
	   .ilfrKo{background-color: rgb(88 88 88) !important; color:#fff !important;}
	   .kgrNUM{background-color: rgb(88 88 88) !important;}
	   .lyjZ {color:#00a94e !important;}
	   .hmxDlj {color:#fff !important;}
	   .bERgGu {background-color:rgb(88 88 88) !important;}
	   .dPYiZw{    color:#0bf !important;}
	   .icdspO {fill: rgb(153 153 153) !important;}
	   .dJIeSZ{background:#295b9b!important;}
	   .dsqYdv{background:#295b9b!important;}
	   .gHCRdA{margin-top: 60px !important;}
	   .cfxYFJ{color:#d3d3d3!important;}
	   .dXHJnq{background:#11213c!important;}
	   .dXHJnq > div:not(:last-child) { border-bottom: 1px solid rgb(56 56 56) !important;}
	   .jEWjTT {background-color: rgb(52 52 52) !important;}
	   .cNvRdW {color: rgb(199 199 199) !important;}
	   .foROpp {color: rgb(179 179 179) !important;}
	   .bfxZzY {color: rgb(244, 238, 255) !important;}
	   .jbatDG {color:rgb(244, 238, 255) !important;}
	   .iqzDdM {color: rgb(177 201 239)!important;}
	   .dVowcx {color:#0bf !important;}
	   .footer .dVowcx{color:#fff !important;}
	   .hRaqMf{margin-top: 50px !important;}
	   .IIoEE{background:#030e28!important;}
	   .iNqUwB {border:2px solid rgb(15 44 68)!important;}
	   .bwUnQf {color:#00a94e !important;}
	   .dAjPfa {color:#00a94e !important;}
	   .jivNKa{color:#00a94e !important; border:2px solid #00a94e !important;background:#172336!important;}
	   .cbprTg{fill:#00a94e !important;}
	   .enElVT {fill:rgb(116 172 217)!important;}
	   .lmpacG{background:#081934!important;}
	   .euzEbv{background:#081934!important;}
	   .gxTciK{border-bottom: 1px solid rgb(48 48 48) !important;}
	   .erWspI{color: rgb(179 179 179) !important;}
	   .kSZLgi{background: #2c2f36 !important;}
	   .ftwrLA{border: 2px solid rgb(60 60 60) !important; }
	   .jvtpQw:disabled, .jvtpQw.pancake-button--disabled{background-color: rgb(56 56 56) !important;color: rgb(154 154 155) !important;}
	   .cFcZfb {color: #0bf!important;}
	   .gaOzMm{background-color: rgb(102 102 102) !important;}
	   .dKnEYM{background: #212429!important;}
	   .dIIroh{background-color:#001e50!important; border: 2px solid #0bf!important; color: #0bf!important;}
	   .dXeNub{background-color: #202930!important; border: 2px solid #0bf!important; color: #0bf!important;}
	   .dIkicJ {color: rgb(191 191 191) !important;}
	   .cFcZfb {color: #0bf !important;}
	   .gTeDdy {color:rgb(94 126 199)!important;}
	   .bPEWMC{border-top:2px solid rgb(39 54 90)!important;}
	   .evPpeV{background:#355185!important;}
	   .elihCo svg {fill: #0bf !important;}
	   .lcIaPP{background:rgb(23 40 90)!important;}
	   .jaoghy:hover {background:rgb(3 21 64)!important;}
	   .cJETlL{background-color: #0bf  !important;}
	   .kJczUE{background-color: rgb(95 94 98) !important;}	
	   .jXkHGR { border-top: 1px solid rgb(58 58 58) !important;}
	   .ZWzup svg {fill: #0bf!important;}
	   .hzIqNw {border-bottom:1px solid rgb(25 40 68)!important;}
	   .bDwUa-d{color:rgb(119 150 209)!important;}
	   .ngPOo {color:rgb(112 139 191)!important;}
	   .edlTfB{background:#030e28!important;}
	   .kcTWrg{border:2px solid rgb(15 44 68)!important;}
	   .cMIDQP{color:#0bf!important;}
	   .jYcrBV{margin-top: 38px !important; margin-left:0px !important;}
	   .kySwEQ {background: #1c1c1c!important; border-bottom: 1px solid rgb(67 67 67)!important;}
	   .cUqdYU{background: #0bf !important;}
	   .bkkQou{color: #0bf!important;}
	   .cRXIHH:hover + .sc-bXexck:not(:disabled):not(:checked) {box-shadow: rgb(1 201 223) 0px 0px 0px 1px, #0bf 0px 0px 0px 4px !important;}
	   .eaFRFo{background:#1c335a!important;}
	   .hIzjHI {color:rgb(188 205 255)!important;}
	   .eizLPZ{fill: #d3d3d3!important;}
	   .kibFjB {color: #0bf !important;}
	   .eIjlfJ {color: rgb(217 217 217) !important;}
	   .dUSdIO {color: rgb(255 255 255) !important;}
	   .dBKRKC{color: #0bf !important;}
	   .bmnHHk {color:rgb(177 209 243)!important;}
	   .aEUEf {color: rgb(135 135 135) !important;}
	   .jrbqkg {background-color: rgb(52 52 52) !important;}
	   .fcgdxw{box-shadow: rgb(31, 199, 212) 0px 0px 0px inset !important;}
	   .fcgdxw svg {fill: rgb(255 255 255) !important;}
	   .bkja-Dq .item img {filter: drop-shadow(rgb(0, 0, 0) 0 0px 0px)!important;}
	   .juTdfy{padding: 0px 18px !important;background:#231F20 !important;}
	   .cQEcuR {color: rgb(232 237 255)!important;}
	   .kZBCcP {color: rgb(41 209 249)!important;}
	   .FYzud{max-height: 588px !important;}
	   .ea-DnwP{padding: 0px 14px !important;}
	   .dBKRKC {margin: 0px 12px 24px !important;}
	   .ea-DnwP:hover {background:#231F20 !important;}
	   .juTdfy:hover{background-color:#121010!important;}
	   .fcgdxw:hover{background-color:rgb(16 47 92) !important;}
	   .koKPxY{background: rgb(26 34 58)!important;}
	   .hhGvQm{border-bottom: 2px solid rgb(44 47 86) !important;}
	   .iMoaEq{background: rgb(16 19 38) !important;}
	   .VJjxu{border: 2px solid rgb(35 48 76) !important;}
	   .iPHzGx:disabled, .iPHzGx.pancake-button--disabled{background-color: rgb(11 57 102) !important;    color: rgb(159 182 227) !important;}
	   .cNcyJu{font-weight: 500 !important;}
	   .eBeWGj {background-color: rgb(29 65 116) !important;}
	   .hNgWPF{background: rgb(18 28 60) !important;}
	   .fShtai{border-bottom: 2px solid rgb(28 39 80) !important;}
	   .gVWcIj{background: rgb(5 9 34) !important;}
	   .fUgcQa{border: 2px solid rgb(32 51 80) !important;}
	   .cqOgdw:disabled, .cqOgdw.pancake-button--disabled{background-color: rgb(47 88 159) !important;color: rgb(139 171 221) !important;}
	   .jfNbTs{border-top: 2px solid rgb(57 74 122) !important;}
	   .gSrYsF{border-top: 2px solid rgb(31 49 80) !important;}
	   .knNpHZ {background-color: rgb(48 52 98) !important;}
	   .kSUXjS{background: #1c335a!important;}
	   .jryLpQ{color: rgb(91 125 205) !important;}
	   .hnsruY{margin: 0px 12px 26px !important;}
	   .gozLQQ{color:#000 !important;margin-left: 38px !important;}
	   .dXHJnq>div:not(:last-child){border-bottom: 1px solid rgb(43 58 92)!important;}
	   .jEWjTT {background-color: rgb(38 52 98)!important;}
	   .kfHjrF {border-right: 0px solid rgba(133, 133, 133, 0.1) !important; width: 0px !important;}
	   .jYcrBV {margin-left:0px !important;  max-width: calc(100% - 0px) !important;}
	   .erbcuZ {border-right: 0px solid rgba(133, 133, 133, 0.1) !important; width: 0px !important;}
	   .hQTETD {margin-left: 0px !important;  max-width: calc(100% - 0px) !important;}	
	   .glXpWd {border-right: 0px solid rgba(133, 133, 133, 0.1) !important; width: 0px !important;}
	   .dKnEYM {background:#001e50!important;    border-bottom: 1px solid rgb(25 53 106) !important;}
	   .cefFiO {border-bottom: 1px solid rgb(25 53 106) !important;}
	   .loBjTJ {border-top: 1px solid rgb(14 50 120);}
	   .bIBYWB{border-radius: 20px !important;}
	   .lgoBcj{background-color: rgb(56 56 56) !important;}
	   .blNUgE{background-color: #00a94e !important; }
	   .kTUvfq{color:#51b0fd !important;}
	   .bXehty{color:#51b0fd !important;}
	   .cUqdYU {background:rgb(5, 175, 81)!important;}
	   .bXehty{background-color: rgb(100 100 103) !important;}
	   .fXogNs{background: linear-gradient(139.73deg, rgb(243 243 243) 0%, rgb(249 249 249) 100%) !important;}
	   .crUvYR{background-color: #00a94e!important;}
	   .dYbBnJ{background-color: #00a94e!important;}
	   .hjhlnp{background-color: #00a94e !important;}
	   .iXcXNn{background-color: #00a94e !important;}
	   .glACab{border: 2px solid #00a94e !important;}
	   .eNRMmt{background-color: #00a94e !important;}
	   .fiwHnU{background-color: #00a94e !important;}
	   .kfjzuc{background-color: #00a94e !important;}
	   .dTTByL{background-color: #00a94e !important;}
	   .fbbmfr{background-color: #00a94e !important;}
	   .fbbmfr{background-color: #00a94e !important;}
	   .fVneWG{background-color: #00a94e !important;}
	   .fRhvwg{color: #00a94e !important;}
	   .griDRH{color: #00a94e !important;}
	   .jLCkxG{color: #fff !important;}
	   .aXUoC{color: #00a94e !important;}
	   .jOMEkI svg{fill: #00a94e !important;}
	   .ieuTwp{color: #00a94e !important;}
	   .dMSGGh{color: #00a94e !important;}
	   .kgufHI{color: #00a94e !important;}
	   .fBnGPs{color: #00a94e !important;}
	   .jOzHhk{color: #00a94e !important;}
	   .ddQfJM{color: #fff !important;}
	   .eqgJAQ{color: #00a94e !important;}
	   .dVosaI{color: #00a94e !important;}
	   .cnGEXC{color: #00a94e !important;}
	   .epqsFo{color: #00a94e !important;}
	   .fHcTm{fill:#00a94e !important;}
	   .jocQRo{border-color: #00a94e !important;}
	   .ghrTej{border-color: #00a94e !important;}
	   .llMJfs{border-color: #00a94e !important;}
	   .iKBaQD{border-color: #00a94e !important;}
	   .lhzPOR{border-color: #00a94e !important;color: #00a94e !important;}
	   .ddHfte{color: #00a94e !important; background-color: rgb(215 215 215) !important;}
	   .ckThwc{color: #00a94e !important;}
	   .kgufHI{color: #00a94e !important;}
	   .ePgSaq{color: #00a94e !important;}
	   .bzdTZe{color: #00a94e !important; background-color: rgb(215 215 215) !important;}
	   .fDVVER{background-color: rgb(215 215 215) !important;border: 1px solid rgb(196 191 207) !important;}
	   .czQdOa{color: #00a94e !important;}
	   .jwZGrk{color: #00a94e !important;}
	   .hAkUgo{color: #00a94e !important;}
	   .lphCVf{color: #00a94e !important;}
	   .hAkUgo{color: #00a94e !important;}
	   .gMCTPT{color: #00a94e !important;}
	   .dqEhap{fill: #00a94e !important;}
	   .epQXPU{fill: #00a94e !important;}
	   .epQXPU{fill: #00a94e !important;}
	   .cGjbTu svg{fill: #00a94e !important;}
	   .gMCTPT{color: #00a94e !important;}
	   .cFsiGO{background-color: #00a94e !important;}
	   .dvwrHD{color: #fff !important;}
	   .gxMHVe{box-shadow: none !important;}
	   .bvbZxG{background: linear-gradient(139.73deg, rgb(86 102 143) 0%, rgb(58 72 98) 100%) !important;}
	   .fjtaEg{background-color: rgb(66 65 62);}
	   .znJTS{background:#08060b !important;}
	   .cOsifD svg{fill:#08060b;}
	   .cqYLEz {color:rgb(0, 169, 78);}
	   .jjodRX{background-color:rgb(30 30 30) !important;}
	   .jSpxPp{   background: linear-gradient(220deg, rgb(194, 241, 226) 0%, rgb(241 232 255) 50%, rgb(158, 229, 204) 99%) !important; margin-top:0px; padding:50px 0px 20px !important;}
	   .cJyzWJ{background:#fff !important; margin-top:0px; padding:0px 0px 0px !important;}
	   .iwyzqg{background: linear-gradient(166.77deg, rgb(98, 173, 136) 0%, rgb(86, 116, 101) 100%) !important;}
	   .iAztLv{color: rgb(60 60 60) !important;}
	   .hVMdqd{margin-top: 35px !important;}
	   
			

			/*--- Live Top-banner---*/
			
	.cbJHZ{background: linear-gradient(76deg, rgb(108 90 63) 0%, rgb(207 177 133) 100%) !important;
	height: 480px;}
	.gLbtoc{background: linear-gradient(76deg, rgb(108 90 63) 0%, rgb(207 177 133) 100%) !important;
	height: 480px;}
	.dbaejl{background: linear-gradient(76deg, rgb(108 90 63) 0%, rgb(207 177 133) 100%) !important;
	height: 480px;}
	.QJgfr{ background:#08060b;}
	.fXkAts svg{fill:#08060b;}
	.jBrEgy{color: #ffffffff;}
	.bmdigB{color: #000;}
	.qVwib svg{fill: #000;}
	.bljWJa {color: #000;}
	.kDKrmc svg{fill:#000;}
	.hRBDOY svg{fill:#000;}
	.cqONZj{font-size:20px;  font-family: sans-serif;}
	.jCWkEO{background-color:rgb(62 60 58);}
	.iGjnoZ{background:#fff;}
	.lpuNEx{color:rgb(122 167 143);}
	.eZoQZl {background:rgb(201 201 201);}
	.dPDDmK{border-radius: 50px;}
	.kZBMae{background-color: rgb(241, 238, 234) !important;}
	.cXZvsP{background-color: rgb(62 60 53) !important;}
	.kioZLl{color: rgb(17, 155, 51);}

	

	.dzHATE{background: linear-gradient(76deg, rgb(108 90 63) 0%, rgb(207 177 133) 100%) !important;
	height: 480px;}
	.eQnPRE{background: linear-gradient(76deg, rgb(108 90 63) 0%, rgb(207 177 133) 100%) !important;
	height: 480px;}
	.iymbCd{color: #fff !important;}
	.jUwOCZ svg{fill: #fff;}
	.htyBLV svg{fill: #fff;}
	.dhEAh{color: #000 !important;}
	.dXJzbb {color:#333;}
	.dmsXeE{background-color:#fff !important;}
	.cAAMXf{background-color: #fff; border-bottom:0px solid rgba(133, 133, 133, 0.1) !important;}
	.gdIPrC{background-color: #fff;}
	.ewtrIi{background-color: #fff;}
	
	.gxMHVe svg {fill:#000;}
	.LrBTf{fill:rgb(94 94 94) !important;}
	.kkephe svg {fill: #000;}
	.cqAoBB {background-color: rgb(255 255 255) !important;}
	.cCtSUZ {background-color: rgb(150 145 175) !important;}
	
	.kxqzeX{fill: #000;}
	.cXZvsP{background-color:rgb(62 60 58);}
	.VNRmi{background: rgb(255 255 255) !important;}
	.eFcYAu {background:rgb(219 219 219);}
	.lmkFsq {fill: rgb(26, 167, 68) !important;}
	.hoicjn{border-radius: 50px;}
	.dFeavz:hover {background-color:rgb(110 173 141) !important;}
	.htyBLV:hover{background-color: rgb(84, 137, 109) !important;}
	::-webkit-scrollbar-thumb {background: rgb(0, 167, 103);}
	.lmkFsq {fill: rgb(0, 167, 103) !important;}
	.hdgtcn{background-color: rgb(241 238 234);}
	.jRXrpx { color:rgb(0, 169, 78);}
	.kEacrg{fill:#fff}
	.iloNdM{fill:#fff;}
	.gltnHx{color:#000;}
	.fWcEw {color:rgb(0, 169, 78);}
	.fSEogf{padding-bottom: 32px;}
	.kZBMae{background-color: rgb(241, 238, 234);}
	.lmrrQp{color: #000;}
	.hWscWs{color: #000;}
	.eSxcKn {color: #000;}
	.gVkoaV {color: #00a94e;}
	.gqcxan{fill: #fff !important;}
	.bYpJlH {color: #00a94e;}
	.fxXUKa {color: #000;}
	.erDuOH{background-color:rgb(25 52 38) !important;}
	.ijYyUK{color: rgb(0, 167, 103);}
	.kNvGCz{font-size: 18px;}
	.fGaHvr{font-size: 20px;}
	.gFspdL {color: rgb(0, 167, 103);}
	.hBbeHp {color:rgb(0, 169, 78);}
	.dzQonX{background:#fff;}

	.egstkk{display: none;}
	.cWKPqo{display:none;}
	.ldogCh {border-right: 0px solid rgba(133, 133, 133, 0.1);}
	.gdIPrC{background:#fff !important;}
	.hnXGAw{fill:#333;}
	
	.fxmQLQ{background:#fff;}
	.ckzqFB{background:#fff;}
	

	.bXCMix{fill: rgb(0, 167, 103) !important;}
	.dLoPgX{color:#rgb(179 176 176);}
	.kDKrmc:hover{background-color: rgb(159 209 183);}
	.hRBDOY:hover{background-color: rgb(197 227 211);}
	.iFObfl{background-color: rgb(197 227 211);}
	.iFObfl:hover{background-color: rgb(141 205 172);}
	.kkephe:hover{background-color: rgba(144, 201, 171, 1);}
	.gxMHVe:hover{background-color: rgba(144, 201, 171, 1);}
	.eGJdPz{background-color: rgb(141 205 172);}
	.eGJdPz:hover {background-color:rgb(176 223 198);}
	.doQztz {fill:rgb(155 155 155) !important;}

	

	 .daipcm{background-color: #fff;}
	.gijbzS{background-color: #000000ff; border-bottom: 2px solid rgb(255 255 255 / 20%) !important;}
	.iyHHeq{background-color: #000000ff !important;}
	.jBrEgy{color:#fff;}
	.ioAHvn svg{fill:#fff !important;}

	.qVwib svg{fill:#fff;}
	.qVwib:hover{background-color:rgb(156 209 181);}
	.ioAHvn:hover{background-color:rgb(156 209 181);}
	.ccoIZJ{background-color: rgb(156 209 181);}
	.ccoIZJ:hover{background-color:rgb(178 229 203);}
	.gUxPGx{background-color: #000000ff;}
	.blslWe{background-color: #000000ff !important;}


	.fpNzxn{background-color: #000;}
	.dRfskg{background-color: #000;}
	.iymbCd {color: #fff;}
	.jUwOCZ svg {fill:#fff;}
	.htyBLV svg{fill:#fff;}

	.jUwOCZ:hover{background-color: rgb(84 137 109);}
	.dFeavz{background-color: rgb(84 137 109);}
	.dFeavz:hover{background-color:rgb(37 88 62);}
	.jUGfDE .cMdXbr{fill: #a1a1a1 !important;}
	.fOJgtC{color: #dbc191 !important;}
	.hzGxNc{background-color: #000;}
	.dRfskg{background-color: #000 !important;}
	.jUwOCZ svg {fill:#fff;}
	.htyBLV svg{fill:#fff;}
	.htyBLV:hover{background-color: rgb(84, 137, 109) !important;}
	.dFeavz{background-color:rgb(84, 137, 109) !important;;}
	.dFeavz:hover{background-color: rgb(37, 88, 62) !important;;}
	
	
	


	
			.bcxwfY :nth-child(3){ display:none !important;}
			.eyUYsL{height: 100%; position:absolute; top:20px !important; left:170px !important;}
			.PZZfR span{ color:#fff !important;}
			.fCWFRf{color:#fff !important; font-size: 18px !important;}
			.eiRTmt{color:#fff !important;}
			.bcxwfY{max-height:310px !important;}
			.dsaucM{margin-top: -15px !important;}
			.dsaucM .dsaucM{margin-top: -45px; margin-left:35px;}
			.kgypnk{padding: 0px 7px !important;}
			
	

			/*--- live slider-banner---*/
			.owl-carousel{ display:inline-block !important;}
			.item{float:left; display:inline-block;}
			.dHelQC svg{fill:none !important;    background: #faf9fa;}
			.dIaAJz{background:#faf9fa!important; margin-top:21px !important;padding: 0px 0px 26px !important;}
			.slider {padding:0px 0px 25px !important; margin: auto; overflow: hidden; position: relative; border-left: 0px !important;}
			.slidertitle{border-left: 0px !important; width:100%; text-align:center;}
			.slidertitle .dXSJow{font-size:28px; color:#fff; font-weight:600; margin-bottom:20px; text-transform:uppercase;}
			.slider::before, .slider::after {
			content:""; height:100px; position:absolute; width:200px; z-index: 2;}
			.slider::after {right:0; top:0; transform: rotateZ(180deg);}
			.slider::before {left:0;top:0;}
			.slider .slide-track {-webkit-animation:scroll 50s linear infinite; animation:scroll 50s linear infinite;
			display:flex;}
			.bannerslider{ padding:0px 0px 0px!important; padding-left: 0px !important; width:100%;    margin-bottom: 25px !important;}
			.bannerslider .item img{ width:100% !important; border-radius:10px; filter: drop-shadow(rgb(192, 209, 221) 0px 2px 3px);}
			.slidertitle .bppiMQ{font-size:28px; color:#fff; font-weight:600; margin-bottom:20px; text-transform:uppercase;}
			.emsRjT .PZZfR{ padding-top:25px !important;}
			.bGiqqv{background: none !important;}
			.kydJvJ{padding: 22px 0px 0px !important;}
			.eaNCIZ {margin-top: 0px !important;}
			.knFcWT {padding:0px 7px 0!important; border-left:0px #d7caec solid !important;}
			.bannerslider.item{ width:33% !important;}
			.slide{margin-left: -13px !important;}
			.owl-slider svg{ display:none !important;}


			/*-------------live Footer css ----------- */
			/*-------------live Footer css ----------- */
			.footer a {display:inherit; margin-left:0px; color: #fff; font-size:13px;line-height:29px;font-weight: 500;}
			.mainfooter{padding:0px !important;  flex-direction: inherit !important;    display: inherit !important;}
			.footer {margin-top: 30px; width: 12%; float: left; margin-right: 18px;  margin-bottom: 28px !important;}
			
			.eNqBfW{ padding:0px !important;}
			.footerbox {width:32%; background:#052454 !important;padding:20px 20px 10px; border-radius: 12px;margin-right: 40px; border:1px solid #2c3c76 !important;}
			.footerbox .MlLjM span{ color:#fff;}
			.footerbox .box {display:inherit; font-size: 13px; margin-bottom:5px;font-weight: 500;color:#b7c2ed!important;}
			.footerbox .box .MlLjM{ padding-left:10px;float: right;font-size: 13px; font-weight: 600 !important;}
			.max{ margin-bottom:0px !important; float:right; font-size:13px !important; font-weight:600 !important;   line-height: 16px !important;}
			.box1{background:#dfffed !important;  text-align: center;  border-top: 2px solid rgb(127 201 161);
	border-right:2px solid rgb(127 201 161);  border-bottom:2px solid rgb(127 201 161);  border-image: initial;
	border-radius:20px !important;  padding: 20px 10px !important; border-left: 2px solid rgb(127 201 161) !important;}
			.butbtn {background:#00c0cf; display:inline-block !important; padding:3px 10px; color:#fff !important;
			border-radius:6px; font-weight:600; margin-top:3px; margin-left:5px !important;}
			.buybtnmain{margin-bottom:0px !important; margin-top:15px !important;}
			.telegram{float:left; margin-right: 5px; margin-bottom:10px !important;}
			.telegram:before {font-family:"FontAwesome"; content:"\f1d8";display: inline-block; padding-right: 3px;
			vertical-align: middle;font-weight: 900;}
			.twitter{float:left; margin-right: 5px;}
			.twitter:before {font-family: "FontAwesome";content: "\f099"; display: inline-block; padding-right: 3px;vertical-align: middle; font-weight: 900; color:#fff;}
			
			.github{float:left; margin-right: 5px;}
			.github:before {font-family: "FontAwesome";content: "\f09b"; display: inline-block; padding-right: 3px;vertical-align: middle; font-weight: 900; color:#fff; font-weight: 900; background:#aeaeae; border-radius: 50%; width: 45px; height: 45px; color: #fff;text-align: center; line-height: 40px; margin-right: 8px; font-size: 21px; padding: 2px 0px;box-shadow: 1px 8px 0px rgb(0 0 0 / 20%);}
			
			
			.docs{float:left; margin-right: 5px;margin-bottom: 78px;}
			.docs:before{font-family: "FontAwesome";content: "\f044";  display: inline-block;padding-right: 3px;vertical-align: middle;font-weight: 900; background:#8f3de9; border-radius: 50%; width: 45px; height: 45px;    color: #fff;text-align: center; line-height: 40px; margin-right: 8px; font-size: 21px; padding: 2px 0px;}
			
			.web{float:left; margin-right: 5px;margin-bottom:10px;}
			.web:before{font-family: "FontAwesome";content: "\f0ac";  display: inline-block;padding-right: 3px;vertical-align: middle;font-weight: 900; background:#1281f7; border-radius: 50%; width: 45px; height: 45px;    color: #fff;text-align: center; line-height: 40px; margin-right: 8px; font-size: 21px; padding: 2px 0px;box-shadow: 1px 8px 0px rgb(0 0 0 / 20%);}
			
			
			.rightbox{width:60%; float: left;}
			.leftbox{width:33%; float: left;margin-right: 24px;}
			.token{ margin-top: 2px;}
			.topbox{ margin-bottom:30px !important;}
			.topbox .sc-giAqHp{ float:left !important;margin-right: 6px!important;}
			.buybtnmain .edslEW{margin-top:0px !important;float: left;}
			.topbox img{margin-top:8px;}
			.buybtnmain .lmSvld{float:left !important;margin-top:4px;margin-right:6px;}
			.emsRjT{ padding:0px !important;}
			.kRvGeF{width: 100% !important;}
			.footer svg{display: none !important;}
			.footerbox .box .hmxDlj { padding-left: 10px;  float: right; font-size: 13px; font-weight: 600!important;}
			.hbusih::before{border: none !important;}


			/*------ Farm and pool Live css ----***/
			.bcRTMJ{padding:0px !important; max-width: 100% !important;}
			.farmbanner {max-height: initial !important; max-width: 100% !important; margin-top: 0px !important;}
			.farmbanner .iehvjW{ height:auto !important;}
			.poolbanner{background: #fff;}
			.fVlIww .jcNvwq{display: flex !important;}

			@media only screen and (max-width: 768px) {
			.jfSgvY{right: 0px !important;}
			.eyUYsL{right: 0px !important;}
			.eyUYsL{left: -100px!important;}
			.emsRjT{padding: 12px 0px 30px !important;}
			.swapdiv .col-md-3{width: 100% !important; margin-left: 0px !important; margin-bottom: 15px !important;}
			}

			@media only screen and (max-width: 680px) {
			.footer{width:96% !important;}
			.slide {margin-left:0px!important;}
			.jcNvwq {display: inherit !important; width: 100% !important;}
			.footer {margin-bottom:0px!important; margin-right:0px !important;}
			.leftbox{width:35% !important;}
			.rightbox {width:55% !important;}
			.footerbox .box{font-size: 10px !important;}
			.cNcyJu{font-size:16px !important;}
			.footerbox{padding: 10px 10px 10px !important;}
			.footerbox .box .MlLjM{    font-size:10px !important;}
			.mobile{width:30% !important; float: left;}
			.max{font-size: 12px!important; font-weight: 500!important;}
			.sc-jSFjdj .emsRjT {padding-bottom: 30px !important;}
			.kRvGeF{margin: -12px;}
			.tSBKF{margin-top: 10px;}
			.fAYovO{margin-top: 15px;}
			.footerbox .box .MlLjM{font-weight: 500!important;font-size: 12px!important;}
			}
			@media all and (min-width: 1500px) {
			.item{width:25%;}
			}
	/*--=========== Local System CSS ==============--*/

	 


		/* menu images */

		/* 
	*/
	.header-round-logo {
		width:32px !important;
	}
	.mobile-icon image {
		width:32px !important;
	}
	.desktop-icon image {
		height:26px !important;
	}
	.desktop-icon{width: 200px !important;}

	/*--- Home Local Top-banner---*/
	.sc-ljsmAU .eNqBfW{background: linear-gradient(117.71deg, rgb(0 50 112) 18.76%, rgb(11 77 159) 43.13%, #8f3de9 96.83%), url('images/home/trade/AMPLE.png')!important;}
	.ezpMLt {background: linear-gradient(76deg, rgb(0 63 116) 0%, rgb(0 103 187) 100%) !important; height:430px;}
	.eyNJde{box-shadow: inset 0px 0px 0px #00a94e !important;}
	.kmghxZ :nth-child(3){ display:none !important;}
	.kmghxZ :nth-child(2){}
	.jfSgvY {height: 100%; position:absolute; top:40px !important; left:205px !important; right:0px !important;}
	
	.eRONeq{padding: 0 9px !important;}
	.ioAHvn{padding: 0 9px !important;}
	.sc-ljsmAU .dwlfZz{ border-radius:6px !important;}
	.sc-ljsmAU .dwlfZz:hover{background-color: #6440e9 !important; opacity:1 !important;}
	.bfJRrg span{ color:#fff !important;}
	.eFdPQv{color:#fff !important; font-size:20px !important;}
	.bfJRrg .ggesnF{margin-top:85px; margin-bottom: 9px; font-size: 55px;}

	/*--- Home local slider-banner---*/
	.bhaGOn{margin-left: -0px !important;}
	.hKgMcc{max-width:1080px;}
	.kwFRLp{border-left:0px #d7caec solid !important;}
	.owl-carousel{ display:inline-block !important;}
	.kjFxUt svg {fill:none !important;    background: #faf9fa;}
	.IqOZK{background:#faf9fa!important; margin-top:10px;}
	.slider {padding:2px 0px 25px!important; margin: auto; overflow: hidden; position: relative; border-left: 0px !important;}
	.slidertitle{border-left: 0px !important; width:100%; text-align:center;}
	.slidertitle .dXSJow{font-size:28px; color:#fff; font-weight:600; margin-bottom:20px; text-transform:uppercase;}
	.hPFaoF{text-align: center !important;}


	.bannerslider{ padding:0px 0px 0px!important; padding-left: 0px !important;}
	.item img{ width:100% !important; border-radius:10px;}
	.item a{display: inline !important;}
	.kmghxZ{max-height:310px !important;}
	.bannerslider .bhaGOn {padding: 0 6px !important; border-left:0px #d7caec solid !important; text-align:center;}
	.bhaGOn.slide{padding-left:1px !important;}
	.bhaGOn {padding:0px 0px 0!important; border-left:0px #d7caec solid !important;}
	.klGhwA{ padding:22px 0px !important;}
	.eONuIm{background-color:#1531bb !important;}
	.ihStAN{color:#2b74ff !important;}
	.LGLNe{background-color: #00a94e !important;}
	.bNSBHU{color: #00a94e !important;}
	.faLBaI{color: #00a94e !important;}
	.ePsMKk {color: #00a94e !important;}
	.hlGueA{fill: #00a94e !important;}
	.kCCNlu{background-color:#00a94e !important;}
	


	/*--- Local Footer ---*/
	.footer a {display:inherit; margin-left:0px; color: #fff; font-size:13px;line-height: 26px;}
	.mainfooter{padding:0px !important; flex-direction: inherit !important;}
	.footer {margin-top:12px; width:14%; float: left; margin-right: 18px; margin-bottom:20px !important;}
	.eNqBfW{ padding:0px !important;}
	.footerbox {width:32%; background:#121212;padding:20px 20px 10px; border-radius: 12px;margin-right: 40px; border: 1px solid #383838; }
	.footerbox .jfiVtQ span{ color:#fff;}
	.footerbox .box {display:inline-block !important; font-size: 13px; margin-bottom:5px;font-weight: 500;color:#9fb3d7!important;width: 100%;}
	.cIXZDv{float: right !important;}
	.eilFyC{font-size: 18px !important;}
	.footerbox .token{font-size: 15px !important;}
	.footerbox .box .jfiVtQ{ padding-left:10px;float: right;font-size: 13px; font-weight: 600 !important;}
	.max{ margin-bottom:0px !important; float:right; font-size:13px !important; font-weight:600 !important;   line-height: 16px !important;}
	.box1{margin-bottom:0px !important;display:block !important; font-size:13px!important; font-weight:500 !important; color:#9fb3d7!important;}
	.butbtn {background:#00c0cf; display:inline-block !important; padding:3px 10px; color:#fff !important;
	border-radius:6px; font-weight:600; margin-top:3px; margin-left:5px !important;}
	.buybtnmain{margin-bottom:0px !important; margin-top:15px !important;}
	.telegram{float:left; margin-right: 5px;}
	.telegram:before {font-family:"FontAwesome"; content:"\f1d8";display: inline-block; padding-right: 3px; vertical-align: middle;font-weight: 900; color:#fff;}
	.twitter{float:left; margin-right: 5px;}
	.twitter:before {font-family: "FontAwesome";content: "\f099"; display: inline-block; padding-right: 3px;
	vertical-align: middle; font-weight: 900;}
	.medium{float:left; margin-right: 5px;    color: #fff !important;}
	.medium:before{font-family: "FontAwesome";content: "\f23a"; display: inline-block;padding-right: 3px;vertical-align: middle;font-weight: 900; box-shadow: rgba(0, 0, 0, 0.2) 1px 8px 0px;}
	.rightbox{width:60%; float: left;}
	.leftbox{width:33%; float: left;margin-right: 24px;}
	.token{ margin-top: 2px;}
	.topbox{ margin-bottom:30px !important;}
	.topbox .sc-giAqHp{ float:left !important;margin-right: 6px!important;}
	.buybtnmain .edslEW{margin-top:0px !important;float: left;}
	.topbox img{margin-top:8px;}
	.buybtnmain .cQaGQT{float:left !important;margin-top:4px;margin-right:6px;}

	/*------ Farm and pool Local css ----***/
	.hhDvnH{ padding:0px !important; max-width: 100% !important;}
	.farmbanner {max-height: initial !important; max-width: 100% !important; margin-top: 0px !important;}
	.farmbanner .jLjFSc{ height:auto !important;}
	.ftSPUj .jsxqFW{display: flex !important;}
	
	
	.bkkKbm{background-color: #000 !important;}
	.evhVCK{background-color: #00a94e !important;}
	
	.supplymain{width: 70%; margin: 0 auto;     margin-bottom: 50px !important; display:none !important;}
	.box1{background: #fff; padding: 20px 10px !important; text-align: center;  border-radius:30px 0px;  }
	.iconimage{ margin:0 auto;}
	.bost{margin-top:8px;}
	.whyus{width:100%;}
	.whybox1{width: 50%; float: left; background:#fff; padding: 20px; text-align: left;  border-radius: 10px;}
	.whybox1 h3 { font-size: 24px;  margin-bottom: 10px;  border-bottom: 1px solid #e5e5e5; padding-bottom: 13px;}
	.eNoBFJ{background: url(/images/backgrounds/sliderbg.png) !important;background-size: cover !important;}
	.la-dAcS{background: linear-gradient(166.77deg, rgb(0 0 0) 0%, rgb(0 0 0) 100%) !important;}
	.bzsVuw{background: linear-gradient(220deg, rgb(12, 22, 19) 0%, rgb(35, 48, 42) 50%, rgb(48, 88, 64) 99%) !important;}
	
			

			
/*--=========== New design css ==============--*/			
	.kjEsfZ {background: linear-gradient(180deg, #0f1a24 0%, #00241e 100%) !important;}
	.div1{ float:left; width:65%; align-items: baseline !important; top:20px;    padding-right: 85px;}
	.dwOqkC{text-align:left !important;}
	.div2{ float:left; width:35%;}
	.Twitter{ float:left;}
	.socialbox{ display:inline !important; height:57px;}
	.heading{ margin-bottom:15px !important; text-align:left !important;font-size: 48px;}
	.subtext{font-size:16px !important; margin-bottom:20px; padding: 0px 0px !important; color: #262626ff !important; text-align:left !important; font-width:300px !important; font-family: sans-serif;}
	.telegram{ color:#fff !important; }
	.twitter{ color:#fff !important; }
	.medium{ color:#fff !important;}
	.mainfooter{margin-bottom:20px; padding:50px 28px !important; margin-top:0px !important;border-radius: 10px;}
	.copyright{ background:#000; text-align:center; padding:25px 0px;}
	.copyright p{ color:#fff;    padding-left:0px;}
	.footertop .div1{ width:100%; display: inline;}
	.ggesnF{ margin-bottom: 5px !important; font-size:50px !important; color:#fff !important;}
	.PZZfR{ margin-bottom: 5px !important; font-size:50px !important;}
	.subt{ margin-bottom:20px;}
	.box {float: left; width: 48.2%; padding: 20px; margin-bottom: 20px; margin-right: 20px; height: 320px;
	border-radius: 10px; background: linear-gradient(339deg, #0a0700 0%, #1b9c85 100%) !important;border: 1px solid #1b9c85;}
	.box .heading{font-size:30px !important;}
	.ftop{ padding-top:40px !important;}
	.ftop .heading{ text-align:center !important;}
	.ftop .subt{ text-align:center !important; margin-bottom: 50px !important;font-family: system-ui;}
	.b2{ margin-right:0px !important;width:50% !important;} 
	.subts{color:#51ada4 !important;    margin-bottom: 48px;}
	
	.telegram:before {font-family: "FontAwesome";content: "\f1d8";	display: inline-block;
	padding-right: 3px; vertical-align: middle;	font-weight: 900;background:#00ccfb;			border-radius: 50%;	width:45px;height: 45px;text-align: center;line-height: 40px;margin-right:8px; font-size: 21px; padding: 2px 0px;box-shadow: 1px 8px 0px rgb(0 0 0 / 20%);}
	.twitter{float:left; margin-right:15px;}
	
	.twitter:before {font-family: "FontAwesome";  content: "\f099"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight: 900; background:rgb(19, 160, 255); border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right:0px; font-size: 25px; padding: 2px;box-shadow: 1px 8px 0px rgb(0 0 0 / 20%);}
	
	.youtube{float:left; margin-right:0px;padding: 10px 0px !important;}
	.youtube:before {font-family: "FontAwesome";  content: "\f167"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight:500; background:#db2b2b; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right: 8px; font-size: 25px; padding:0px;color: #fff;box-shadow: 1px 8px 0px #423026;}
	
	.facebook{float:left; margin-right:0px;padding:10px 10px !important;}
	.facebook:before {font-family: "FontAwesome";  content: "\f09a"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight: 900; background:#2b51db; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right:0px; font-size:22px; padding:0px;color: #fff;box-shadow: 1px 8px 0px #423026;}
	
	.linkedin{float:left; margin-right:0px;padding:10px 10px !important;}
	.linkedin:before {font-family: "FontAwesome";  content: "\f0e1"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight:500; background:#00a9f9; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right:0px; font-size:22px; padding:0px;color: #fff;box-shadow: 1px 8px 0px #423026;}
	
	.instagram{float:left; margin-right:5px;padding:0px !important;}
	.instagram:before {font-family: "FontAwesome";  content: "\f16d"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight:500; background:#af6c33; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right: 8px; font-size:22px; padding:0px;color: #fff;box-shadow:rgba(0, 0, 0, 0.2) 1px 8px 0px;}
	
	.pinterest{float:left; margin-right:0px;padding:10px 10px !important;}
	.pinterest:before {font-family: "FontAwesome";  content: "\f231"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight:500; background:#dd0047; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right:0px; font-size:22px; padding:0px;color: #fff;box-shadow: 1px 8px 0px #423026;}
	
	.tiktok{float:left; margin-right:0px;padding:10px 10px !important;}
	.tiktok:before {font-family: "FontAwesome";  content: "T"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight:500; background:#00d2e7; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right: 8px; font-size:22px; padding:0px;color: #fff;box-shadow: 1px 8px 0px #423026;}
	
	.medium{float:left; margin-right: 5px;}
	.medium:before{font-family: "FontAwesome";content: "\f23a"; display: inline-block; padding-right: 3px; vertical-align: middle; font-weight: 900; background:#00b784; border-radius: 50%; width: 45px; height: 45px;
	text-align: center; line-height: 46px; margin-right: 8px; font-size:20px; padding: 2px;}
	
	.copyright a{color:rgb(0 225 104) !important;}
	.kjEsfZ{background: linear-gradient(180deg, #00a94e 0%, #00a94e 100%) !important;}
	.hciSNz{margin-left:22px;}
	
	.fiJuhi{margin-top:2px;}
	.cYzMvz{background-color: #00a94e !important;}
	.sbox{ width:100%; background:#edfcf5; padding:7px; height:auto !important; border-radius:10px; border: 1px solid rgb(181 213 196);}
	.poolsmain h2{ font-size:26px !important;}
	
	.dOwEYQ{color: ##00a94e !important;}
	.dxcQAR{color: ##00a94e !important;}
	.gITSWs{fill: ##00a94e !important;}
	
	
	.uZaiM{border-radius: 5px !important;}
	.lnYGTS{border-radius: 5px !important;}
	.socialbox a:hover{text-decoration: inherit !important;}
	.MbNar{background:#08060b !important;}
	.bkja-Dq {background:#08060b!important;}
	.bJRfKF{top: 10px !important;}
	.cLDXsG{top: 10px !important;}
	.hPFaoF{background: linear-gradient(180deg, #00a94e 0%, #00a94e 100%) !important;}
	.gciivy{margin-left:42px !important;}
	.dsaucM .PZZfR{margin-top: 85px;}
	.gqRfOs{background: linear-gradient(180deg, #00a94e 0%, #00a94e 100%) !important;}
	.ehqnWq{background:#08060b !important;}
	.cIjbuc{background-color: #00a94e !important;}
	.hsThIT{color: #00a94e !important;}
	.jHifAf{fill:#00a94e !important;}
	.fdWAOl{background-color: #00a94e !important;}
	.gGniaK{color: #00a94e !important;}
	.lcFbAY{background-color: #00a94e !important;}
	.iIdAKa .lnYGTS{background-color:#00a94e !important;}
	.duyiqw svg {fill: #00a94e !important;}
	.ikEYGq{fill:#00a94e !important;}
	.kJmatq .lnYGTS{background-color: #00a94e !important;}
	.ejylPG svg{fill:#00a94e !important;}
	.enSRRW .jzKRCf{fill:#00a94e !important;}
	.fAYopv .jzKRCf{fill: #00a94e !important;}
	.hXkuXL{border: 2px solid #00a94e!important; color: #00a94e !important;}
	.dTgGdR{border: 2px solid #00a94e!important; color: #00a94e !important;}
	.kBpHGw{border: 2px solid #00a94e!important; color: #00a94e !important;}
	
mainfooter
.cTLyvI{background: linear-gradient(rgb(133 108 46) 0%, rgb(80 69 55) 100%) !important;}
.sc-iGgWBj .iJsdQo{background: linear-gradient(117.71deg, rgb(94 77 44) 18.76%, rgb(102 81 40) 43.13%, #c39d65 96.83%) !important;}
.sc-iGgWBj .ldYHMg{background: linear-gradient(117.71deg, rgb(94 77 44) 18.76%, rgb(102 81 40) 43.13%, #c39d65 96.83%) !important;}
.sc-iGgWBj .cnKIGB{background: linear-gradient(117.71deg, rgb(0 50 112) 18.76%, rgb(11 77 159) 43.13%, #8f3de9 96.83%)!important;}
.sc-iGgWBj .ikya-dx{background: linear-gradient(117.71deg, rgb(0 50 112) 18.76%, rgb(11 77 159) 43.13%, #8f3de9 96.83%)!important;}
.gIqPTF{background: linear-gradient(rgb(43, 196, 112) 0%, rgb(40, 112, 72) 100%) !important;}
.cqglhx{background: linear-gradientrgb(43, 196, 112) 0%, rgb(40, 112, 72) 100%) !important;}
.gBDiGg{background: linear-gradient(rgb(43, 196, 112) 0%, rgb(40, 112, 72) 100%) !important;}
.bOTTxS{padding-top: 70px !important;}	
.whyus .heading span{color:#000 !important;}
.hplsoI span{ color:#fff !important;}
.div1 h2{color:#000;}
.whyus h2{color:#000;}

.cqONZj{color:#fff !important;}
.kNvGCz{color:#fff !important;}
.duOZiA{ display:none;}
.duOZiA{display:none;}
.eQBPXj{color: rgb(111 211 157) !important;}
.gODbvl{color:rgb(0, 169, 78) !important; border:2px solid rgb(0, 169, 78) !important; background: rgb(255 255 255) !important;}
.gIqPTF .gWaorc{display:none;}
.iCTUzu{background-color: #00a94e !important;}
.etvZGU{background-color: #00a94e !important;}

.lagXlt{background-color: #00a94e !important;}
.bLSFob{background-color: #00a94e !important;}
.ikya-dx .dvXSOK{background-color: #00a94e !important;}
.cnKIGB .bNIgDb{background-color: #00a94e !important;}
.kWMwhQ{background-color: #00a94e !important;}
.hfBnAj{background-color: #00a94e !important;}
.ilKriU{background-color: #00a94e !important;}
.bufLzN svg{fill:#00a94e !important;}
.gxMHVe{box-shadow: none !important;}
.iQkfRR{background-color: #00a94e !important;}
.VxQN{background-color: #00a94e !important;}
.cnGEXC{color: #00a94e !important;}
.boA-dzP{color: #00a94e;}
.eiisoL{color: #00a94e !important;}
.lmkFsq{fill: #00a94e !important;}
.jUwOCZ{box-shadow: #00a94e 4px 0px 0px inset !important;}
.eiisoL{fill: #00a94e !important;}
.kqfnjw svg {fill: #00a94e !important;}
.gxMHVe{box-shadow: #00a94e 4px 0px 0px inset !important;}
.jeDJvD{color:#00a94e !important;}
.eNCTOu{background:#08060b !important;}
.fwwlBf{background:#08060b !important;}
.lcMqSF svg{fill:#08060b !important;}
.iCFoxT{ color:#fff !important;     font-size: 20px;font-family: sans-serif;}
.dvwrHD{margin-bottom: 4px !important;}
.fGaHvr{color:#fff !important;}
.bqQJou{padding-top: 52px !important;}
.gWaorc{left: 120px !important;}
.hzGxNc{top: -8px !important;}
.fkPWxB{fill: #00a94e !important;}
.bAsdjp{margin-bottom: 10px !important;color: #00a94e !important;}
.ffoSVU{color: #00a94e !important;}
.kZLdNV{background-color: #00a94e !important;}
.fCNQBY{color: #00a94e !important; border: 2px solid #00a94e !important;}
.NVlTY{background-color: #00a94e !important;}
.cnGEXC{color: #00a94e !important;}


	
	.cLfYeE{ display:none !important;}
	.jiEujf{display:none !important;}
	.dqQYQQ{    box-shadow: rgb(0 0 0) 4px 0px 0px inset !important;}
	.giuPYt{box-shadow: rgb(255 255 255) 4px 0px 0px inset;}
	.fRQJEU {color:#000;}
	.hlzTIP{background-color: #00a94e !important;}
	.wKOEV{ color:#fff;    font-size:18px !important;}
	.knAhxR{fill:#00a94e !important;}
	.fAwZeF{fill:#000;}
	.hQbuhK{ color:#333;}

	.cCrFph {
	position: fixed !important;
	width: 62% !important;
	background: none !important;
	padding-top: 6px !important;
	z-index: 22 !important;
	left: 120px !important;
		height: auto !important;
	}

	.kpBll {
	position: absolute !important;
	right: 0px !important;
	top: 6px !important;
	border-top: 0px solid rgba(133, 133, 133, 0.1) !important;
	display: inline-flex !important;
	width: 145px !important;
   }

   .cDuLPV {
	width: 55% !important;
	z-index: 22 !important;
	left: 160px !important;
	height: 55px !important;
	background: #fff !important;
	border-right: 0px solid rgba(133, 133, 133, 0.1) !important;
	padding-top: 5px !important;
	}
 .fgbIEi {top: -4px !important;}
 .jiEujf{ display:none;}
 
 .fXzyAZ svg {fill: none;}
 .cJTRrC svg{fill: none !important;}
 .fXzyAZ svg{fill: none;}
 .bezDMm{padding-top:70px;padding-bottom:50px;}
.eTWWEz{ background:none;}
.cJTRrC svg {fill: none;}
.cDuLPV{background:none !important;}
.fVgwDj {height: 100%; position: absolute; top: 30px !important; left: 90px !important;}
.dMEXfY{margin-bottom: 7px;}
.dqQYQQ{box-shadow: rgb(0 0 0) 4px 0px 0px inset;}

.bstDfm{
	width: 60% !important;
	z-index: 22 !important;
	left: 158px !important;
	height: 55px !important;
	background: #fff !important;
	border-right: 0px solid rgba(133, 133, 133, 0.1) !important;
	padding-top: 5px !important;
	}
	.faCjVB {
	width: 57% !important;
	z-index: 22 !important;
	left: 150px !important;
	height: 55px !important;
	background:none !important;
	border-right: 0px solid rgba(133, 133, 133, .1) !important;
	padding-top: 5px !important;
}
	.dleCaj {
	position: absolute !important;
	right: 0 !important;
	top: 6px !important;
	border-top: 0 solid rgba(133, 133, 133, .1) !important;
	display: inline-flex !important;
	width: 145px !important;
}
	.bstDfm{background: none !important;}
	.kLdwNe{box-shadow: rgb(0 0 0) 4px 0px 0px inset !important;}
	.kAOsVi svg {fill: none !important;}
	.fjNeiz{top: -4px !important;}
	.eYrUbv{box-shadow: rgb(255 255 255) 4px 0px 0px inset !important;}
	.khvwTx{color:#fff !important;}
	.cTeDrK{ display:none !important;}
	.gGSqVt{display:none !important;}
	.giuPYt{box-shadow: rgb(255 255 255) 4px 0px 0px inset !important;}
	.wKOEV{ color:#fff !important;}
	.gZeiLR svg {fill: none !important;}
	
	.cbYMoy {
	width: 57% !important;
	z-index: 22 !important;
	left: 150px !important;
	height: 55px !important;
	background:none !important;
	border-right: 0px solid rgba(133, 133, 133, .1) !important;
	padding-top: 5px !important;
}

.fXzyAZ svg { fill: none !important;}
.whychooseus{background: url(/images/backgrounds/socialbg.png) !important; padding:50px 22px;     display: block; background-size: cover !important;}
.whychooseus h2{ color:#000 !important; margin-top:22px;}
.mainfooter h2{color:#000 !important; margin-top: 20px !important;}
.cJmREw{border-top: 2px solid rgb(225 225 225) !important;}	
.mainfooter .subtext{font-size:20px !important;     line-height: 35px;}
.whyusimage{ width:34%; float:left;}
.whyusimage img{    margin-left:0px;}
.whyus{width:64%; float:right; display: inline; margin-left:8px;}








@media only screen and (max-width: 768px) {
	.jfSgvY{right: 0px !important;}
	.eyUYsL{right: 0px !important;}
	.eyUYsL{left: -100px!important;}
	.emsRjT{padding: 12px 0px 30px !important;}
}

@media only screen and (max-width: 680px) {
	.footer{ width:95% !important;}
	.bhaGOn { width: 100% !important; margin-bottom:5px;}
	.footer {margin-bottom: 10px!important; margin-right:0px !important;}
	.leftbox{width:35% !important;}
	.rightbox {width:55% !important;}
	.footerbox .box{font-size: 10px !important;}
	.eilFyC{font-size:11px !important;}
	.ksnaJT{font-size: 14px !important;}
	.tSBKF{font-size: 14px !important;}
	
	.footerbox{padding: 10px 10px 10px !important;}
	.footerbox .box .MlLjM{    font-size:10px !important;}
	.mobile{width:30% !important; float: left;}
	.max{font-size: 10px!important;}
	.sc-jSFjdj .emsRjT {padding-bottom: 30px !important;}
	.sc-ljsmAU .dwlfZz {margin-bottom: 40px;}
	.slider .slide-track{width: inherit;width: 100% !important;}
	.bannerslider .bhaGOn{padding: 6px 0px !important;}
	.bannerslider .item img{width: 100% !important;}
	.jsxqFW {width: 100%;}
	.owl-slider svg{ display:none !important;}
	.footerbox .box .jfiVtQ{font-weight:500 !important;}
	.logoslider {width:117% !important; text-align: center;}
	.plogo{ width:100% !important;}
	.jfSgvY{left: -33px !important;}
	.slider{width:550% !important;}
}

/*--- Local Footer ---*/
.logoslider{width:106.7%; margin-left: -24px; text-align:left; padding-left:24px; padding:20px 30px 50px; background: linear-gradient(270deg, rgb(6 34 76) 0%, rgb(3 60 151) 100%);}
.logoslider .title{color:#280D5F; font-size:26px;  margin-top:-5px;}
.logodiv .plogo{ display:inline-block;margin:10px;margin: 3px 10px 9px 0px; float:left !important;}
.lastlogo{ margin-bottom:20px !important;}
.plogo img{border-radius: 10px; height: auto !important; border: 1px solid #253e78;    border: 1px solid #2d4a8d; padding: 9px 0px;}
.heding{font-size:24px !important; color: #fff !important; margin-bottom: 12px !important; text-align:left;}
.plogo{width: 22.8% !important; max-height:56px !important;}
.logodiv{text-align: center; margin-bottom:0px !important;}
.Exchange{ padding-bottom:0px !important; padding-top:40px !important;}
.Exchange a{display: revert !important;}
.Exchange a svg{ display:none !important;}
.CNDtP{color: #00a94e !important;}
.ctFTfa .cA-DCli{color: #00a94e !important;}
.ctFTfa .fDWAQC{color: #00a94e !important;}
.ctFTfa .kCGGcE{color: #00a94e !important;}
.eclIKG .cMDZmi{color: #00a94e !important;}
.jzKRCf{fill: #00a94e !important;}
.eMbowG img{ display:none;}
.ctXwEB{ display:none !important;}
.erKMmf{display:none !important;}
.jbSrla{display:none !important;}
.kDKrmc{ box-shadow:none !important;}
.jUwOCZ{box-shadow:none !important;}
.duOZiA{ display:none !important;}
.jGcBX{border: 2px solid #00a94e !important;     color: #00a94e !important;}


@media all and (min-width: 1500px) {
	.plogo{width: 11.2% !important; max-height: inherit!important; max-width: inherit!important;}
	.logoslider{width: 105.7%;}
}


@-webkit-keyframes scroll {
	0% {transform: translateX(0);}
	100% {transform: translateX(calc(-83px * 12));}
}
@keyframes scroll {
	0% {transform: translateX(0);}
	100% {transform: translateX(calc(-83px * 12));}
}
.slider::before, .slider::after {
content:""; height:200px; position:absolute; width:300px; z-index: 2;}
.slider::after {right:0; top:0; transform: rotateZ(180deg);}
.slider::before {left:0;top:0;}
.slider{-webkit-animation:scroll 24s linear infinite; animation:scroll 24s linear infinite;
display:flex;width:250%;}
.goHtuF span{ color:#000 !important;}

.eqxEEh{margin-bottom: 18px !important;}
.fiwnqH {top:30px !important;}
.calTzJ svg{transition: transform 0.3s;  border: 2px solid #ddd; border-radius: 50px;}
.fMlQxR svg {transition: transform 0.3s;  border:2px solid rgb(221 221 221); border-radius: 50px;background: #fff;}
.cUhZeQ{top:15px !important;  left: 120px !important;}
			


		/*--=========== Local top MENU light theme CSS ==============--*/
@media only screen and (max-width: 767px) {
	.iafQTd {position: fixed !important;  width: 240px !important;height: 490px !important;}
	.dFIpZl{position: fixed !important;  width: 240px !important;height: 490px !important;background: #212429!important;}
	.iHIYBB{ left:0px !important; width:240px !important;height:100% !important;}
	.dFIpZl{ left:0px !important; width:240px !important;height:100% !important;}
	.fOIjHO { display: inherit !important; height: auto !important;height: auto !important;	margin: inherit!important;}
	.iafQTd {left:0px !important; top:64px !important;}
	.iafQTd {background: #fff !important;}
	.gBgtjB {position: inherit !important; top: 0px !important;}
	.XHRHE{ display:block !important;}
	.iHIYBB .dJgaKe {right: -108px !important;}
	.dJgaKe {position: initial !important;    margin-top: 80px !important;}
	.lahCMV .kTkJfq {right: -108px !important;}
	.kTkJfq {position: initial !important;    margin-top: 80px !important;display: inline !important;}
	.dNoXqi {padding-bottom:30px !important; padding-top:30px !important;}
	.gBgtjB{ display:block;}
	.XHRHE{ display:block !important;}
	.duOZiA{display:block !important;}
	.erKMmf{display:block !important;}
	.kTkJfq {background: #27262c !important;width: 240px !important;}
	
	
	.lahCMV {width:240px!important; height:490px!important; left:1px!important; top:62px!important;
	background: #212429!important;}
	.dXqMpX {display: block !important;}
	.kjeVWL{margin-right: 8px !important;}
	.hMAoqP {margin-left: 0px !important;}
	.ckzqFB {
		position: fixed !important;
		top: 6px !important;
		left: 0 !important;
		z-index: 22 !important;
		height: 100% !important;
	}
	/*--=========== Local top MENU CSS light theme End ==============--*/
}
		
		
		
/*--=========== lIVE Top MENU CSS Light Theme ==============--*/
@media only screen and (max-width: 767px) {
	.iyHHeq{position: initial !important;    margin-top: 80px !important;display: inline !important;}
	.dRfskg{position: initial !important;    margin-top: 80px !important;display: inline !important;}
	.gdIPrC{margin-top: 80px !important;display: inline !important;}
	.dmsXeE{margin-top: 80px !important;display: inline !important;}
	.dmsXeE{margin-top: 80px !important;display: inline !important;}
	.blslWe{position: fixed !important;  width: 240px !important;height: 490px !important;background: #212429!important;}
	.blslWe {position:fixed !important;  width: 240px !important;height:100% !important;left:0px !important; top:60px !important;background: #000 !important;}
	.krBTMC{width: 240px !important;height:100% !important;left:0px !important; top:64px !important;background: #000 !important;display: flex !important;  z-index: 11 !important; overflow: initial !important; transform: translate3d(0px, 0px, 0px) !important;}
	.LYkex{width: 240px !important;height:100% !important;left:0px !important; top:64px !important;background: #000 !important;display: flex !important;  z-index: 11 !important; overflow: initial !important; transform: translate3d(0px, 0px, 0px) !important;}
	
	.cCrFph{width: 240px !important;height:100% !important;left:0px !important; top:64px !important;background: #072435 !important;display: flex !important;  z-index: 11 !important; overflow: initial !important; transform: translate3d(0px, 0px, 0px) !important;}
	.cDuLPV{width: 240px !important;height:100% !important;left:0px !important; top:60px !important;background: #072435 !important;display: flex !important;  z-index: 11 !important; overflow: initial !important; transform: translate3d(0px, 0px, 0px) !important;}
	
	.leRYVS{display: inherit !important;height: 390px !important;}
	.cVnNS{display: inherit !important;height: 390px !important;}
	.blslWe{display: initial !important;}
	.iyHHeq {display: block!important; position: absolute !important; right: inherit!important; top: initial!important;  width: auto!important; bottom:70px !important;}
	.dRfskg {display: block!important; position: absolute !important; right: inherit!important; top: initial!important;  width: auto!important; bottom:70px !important;}
	
	.kpBll {display: block!important; position: absolute !important; right: inherit!important; top: initial!important;  width: auto!important; bottom:70px !important;}
	
	.jcNvwq {width: inherit !important;}
	.swQgw{padding: 0px 10px !important;}
	.fAYovO {margin-top:0px !important;}
	.ctXwEB{ display:block !important;}
	.jbSrla{display:block !important;}
	.knFcWT {padding: 0 7px 10px 0px!important;}
	.gdjqro{margin-right: 0px !important;}
	.dJgaKe{display: inline !important;}
	.div1{ width:100% !important;     padding-right: 0px !important; margin-bottom: 15px !important;}
	.whyusimage{width:100% !important;}
	.eNoBFJ{    padding-bottom: 25px !important;}
	.whyus{width:100% !important;     margin-left:0px !important;}
	.gWegUx{    margin-bottom: 4px !important;}
	.div2{width:100% !important;}
	.efbDcL{overflow:inherit !important;}
	.gWaorc {left: -90px !important;     top: 10px !important;}
	.hzGxNc{top: -4px !important;}
	.fxmQLQ{top: -4px !important;}
	.whyusimage img {margin-left: 0px !important;}
	.cyfBTY {font-size: 38px !important;}
	/*--=========== lIVE Top MENU CSS Light Theme End ==============--*/
	
	/*--=========== lIVE Top MENU CSS Dark Theme ==============--*/
	.elSHRO {width: 240px !important; height:100% !important; left:0px !important; top:64px !important; background:#231F20!important;}
	.ldogCh{width: 240px !important; height:100% !important; left:0px !important; top:64px !important; background:#fff!important;}
	.jRJONp {display: block !important;}
	.eNPaSS {fill: #fff !important;}
	.leRYVS{margin: inherit !important;}
	.cVnNS{margin: inherit !important;}
	.jZAWNq{background-color:#353132!important;}
	.dUzoQC{margin-top:105px !important;}
	.mobilelast a {float: inherit !important;}
	.senterbox {text-align: left !important;}
	.senterbox a{padding-left: 0px !important;}
	.daipcm{position: initial !important; width: 240px !important;}
	.gdIPrC {background-color: #ffffffff!important;right: 0!important;display: initial!important;bottom: 60px !important;}
	.dmsXeE {background-color:rgba(255, 255, 255, 1)!important;right: 0!important;display: initial!important;bottom: 60px !important;}
	.dmsXeE {right: 0!important;display: initial!important;bottom:20px !important;}
	
	.mobilelast a{padding-left: 0px !important;}
	.YaON{padding: 0px 0px !important;}
	.kgypnk {padding-left: 0px !important;}
	.erAkNO{display: inline-flex !important;padding: 0px 8px !important;}
	.erAkNO .jcNvwq .jaFhcY {display: block !important;margin-right:5px !important; margin-left:20px !important;}
	.erAkNO .jcNvwq .heXOmK {display: block!important;}
	.iyHHeq{    padding:0px 4px !important;}
	.dRfskg{    padding:0px 4px !important;}
	.footerbox .cNcyJu {font-size:11px!important;}
	.elSHRO{display: initial !important;}
	.kdpiTO {color: rgb(255 255 255) !important;}
	.owl-slider .jcNvwq{padding: 0 4px 10px 0!important;}
	.blslWe{z-index: 11!important;}
	.daipcm {position:fixed !important; top:60px !important;  left:0px !important; z-index:22 !important; height: 100% !important;}
	.ldogCh {position:fixed !important; top:58px !important;  left:0px !important; z-index:22 !important; height: 100% !important;}
	.faCjVB {position:fixed !important; top:60px !important;  left:0px !important; z-index:22 !important; height: 100% !important;  background: #000 !important;}
	.max{font-size: 11px !important;}
	.gdIPrC{top: initial !important; width: 100% !important; right: initial !important;}
	.dmsXeE{top: initial !important; width: 100% !important; right: initial !important;}	
	.footerbox .box .hmxDlj{font-size: 11px !important;}
	.gqRfOs{ text-align:center !important;background:#141112!important;}
	.glZmJR{width: 100% !important; display: block !important;}
	.hsThIT{padding: 0px 2px !important;}
	.bmnHHk {color: rgb(191 191 191)!important;}
	.daipcm .gdIPrC {top: auto !important;}
	.ldogCh .dmsXeE {top: auto !important;}
	.gGniaK{padding: 0px 2px !important;}
	.supplymain {width: 100% !important;}
	.gUYCYM{display: inline-block !important;}
	nav .jcNvwq {margin-bottom: 0 !important;}
	.poolstitle{margin-bottom:20px !important;}
	
	.socialbox{display: inline-block !important; margin-top: 0px !important; height: 57px;}
	.socialbox a{ width:auto !important;color: #ffffff !important;}
	.mainfooter{padding: 20px !important; }
	.telegram{margin-left: 2px !important;    margin-bottom: 15px !important;}
	.PZZfR{font-size: 35px !important;}
	.bPXhdH{font-size: 15px !important;}
	.gciivy {margin-left: 0px !important;}
	.dsaucM {margin-top: -125px !important;}
	.eyUYsL{top: -7px !important;}
	.jlfCqs:hover .efbDcL{display: inline-masonry !important; }
	
	.hJmLNi{margin-right:5px !important;}
	.kRvGeF{padding-top:0px !important;}
	.box1{margin-bottom: 0px !important;}
	.dIaAJz{margin-top: 0px !important;}
	.dXoxDi{padding-top: 35px !important;}
	.jYcrBV{margin-top: 58px !important;}
	.cTeDrK{ display:block !important;}
	.gGSqVt{display:block !important;}
	.cLfYeE{ display:block !important;}
	.jiEujf{display:block !important;}
	.fVgwDj{top: 0px !important; left: -150px !important;}
	.cwstHk{left: -110px;}
	.gmqVni{align-items: normal !important;}
	.subtext{margin-bottom: 25px !important;}
	.hnXGAw{fill:#000;}
	
	.gTdLKM{padding-bottom: 40px !important;}
	.goYmnT{background: #fff !important;}
	.web{margin-bottom: 18px !important;}
	.ipJceX{padding: 0px 4px !important;}
	.gWegUx{width: auto !important;}
	.heading{font-size: 32px !important; width: 100% !important;}

	.ecUFJO{margin-right: 10px;}
	.jimpXK{margin-right: 10px;}
	.sbox{ background:rgb(208, 241, 228) !important; padding:0px !important;  padding-left: 10px !important;}
	.ecUFJO{margin-bottom:5px;}	
	.jimpXK{margin-bottom:5px;}
	.jimpXK{margin-bottom:3px;}
	.dvASaT{grid-template-columns: repeat(2, auto) !important;}
	.dBGiSj{grid-template-columns: repeat(2, auto) !important;}
	.cicaEX{margin-bottom: 0px;}
	.ircWHH{font-size:13px !important; margin-bottom: 0px !important;}
	.cyYtEE{padding-bottom: 6px !important;}
	.bDdQc{padding-bottom: 5px;}
	.fiwnqH {top:30px !important; left: -130px;}
	

}
@media only screen and (max-width: 400px) {
	.ircWHH {font-size: 13px !important;}
	.wFARf{font-size: 18px !important;}
	.bDdQc{font-size: 15px !important;}
	 .jimpXK { margin-bottom: 0px !important; }
}
	

.bxXYoA{ color:#000;}
.bWshlh{color:#000 !important;}
.ijAJYq svg{fill:#fff !important;}

.jgurgk{background: linear-gradient(166.77deg, rgb(98 126 112) 0%, rgb(23 54 38) 100%) !important;}
.gYIqgm{background: linear-gradient(166.77deg, rgb(98 173 136) 0%, rgb(86 116 101) 100%) !important;}
.dDnVPe{background: linear-gradient(166.77deg, rgb(98 173 136) 0%, rgb(86 116 101) 100%) !important;}

.cFUuuH{background: linear-gradient(111.68deg, rgb(195 227 210) 0%, rgb(62 106 83) 100%) !important;}

.eZoQZl {background: rgb(51 86 68);}
.gUIrso{border-top:1px solid rgb(211 211 211);}
.gRaqKW{color:#fff !important;}
.iOKGcI {color: rgb(45 203 118) !important;}
.kUUQNY{border: 2px solid rgb(0, 169, 78) !important; background: rgb(243 243 243); color: rgb(0, 169, 78) !important;}
.eIpqGd{background-color: rgb(39 39 54) !important; border: 1px solid rgb(34 30 42) !important;}
.dqGZQX{background-color:#fff !important; border: 1px solid rgb(255 255 255) !important;}
.dVMUNB{ color:#fff !important;}
.dAvOtu{color:#fff !important;}
.eZVocA{color: rgb(0 199 92) !important;}
.gMyQTk{color: rgb(0, 169, 78) !important;}
.cIZEUx{color: rgb(0, 169, 78)!important;   border: 2px solid rgb(0, 169, 78)!important;}
.hJeyno{color: rgb(0, 169, 78) !important;}
.eYgpjJ{background: linear-gradient(111.68deg, rgb(222 243 232) 0%, rgb(186 229 206) 100%) !important;}
.jJiJgI{background: linear-gradient(111.68deg, rgb(79 143 109) 0%, rgb(186, 229, 206) 100%) !important;}
.eBoTd {fill: rgb(0 0 0) !important;}
.fPfTeW{background-color: rgb(0, 169, 78) !important;}
.cCAcNH{background-color: rgb(0, 169, 78) !important;}

.lkIybG{background-color: rgb(0, 169, 78) !important;}
.cvfnvY{color: rgb(0, 169, 78) !important;}
.cstgAE{color: rgb(0, 169, 78) !important;}
.framaF{background: rgb(4 4 4);}
.dEDbnd{background: linear-gradient(139.73deg, rgb(71 124 96) 0%, rgb(41 76 58) 100%);}
.TymmC {color:#000;}
.poolsmain .TymmC {color: #000 !important;}
.cvUFcs{background-color: rgb(84, 137, 109) !important;}
.HygOc{color: rgb(46 46 46) !important;}
.gHYqWv{color: rgb(46 46 46) !important;}
.bbChbf{background-color: rgb(0, 169, 78) !important;}
.kkQNzu{background-color: rgb(84, 137, 109) !important;}
.eELXoP{color: rgb(106 169 135) !important;}
.cOZJQe svg {fill: rgb(0, 169, 78) !important;}
.dkwhJx{color: rgb(84, 137, 109) !important;}
.bTtjmS svg{fill: rgb(0, 169, 78) !important;}
.hJeyno .gucsmc{background-color: rgb(0, 169, 78) !important;}

.cyfBTY{font-size:50px !important;     }
.AZZcK{margin-top: -20px !important;}
.gTdLKM .dvXSOK { background-color: #00a94e !important;}
.dvXSOK{background-color: rgb(0, 169, 78) !important;}
.lDjiJ{background: rgba(255, 255, 255, 1) !important;}
.esYQUp svg{fill:rgba(255, 255, 255, 1) !important;}
.goYmnT{    background: rgba(255, 255, 255, 1) !important;}
.iaWmww{color:#000 !important;}
.bnIlSp{color:#000 !important;}
.iylpJg{color:#000 !important;}
.cQjsth span{color:#000 !important;}
.fxXUKa {color:#000 !important;}
.gTdLKM{padding: 4px 0px !important;}
.fOJgtC {color:#fff !important;}
.cbCvFc svg {fill: rgb(0, 169, 78) !important;}
.fRfEkS{color: rgb(0, 169, 78) !important;}
.fvGSig{margin-top: 0px;  background:#fff !important;    padding:0px 0px 0px !important;}
.eQIYFA{background: #fff !important;
	padding:0px 0px 0px !important;}
.eQBPXj {color: rgb(0, 169, 78) !important;}
.bNIgDb{background-color: rgb(0, 169, 78) !important;}
.jzIYNn{background: linear-gradient(166.77deg, rgb(59 157 108) 0%, rgb(0 0 0) 100%) !important;}
.Tpqhx{color: #fff !important;}
.fLWEug{color: rgb(0, 169, 78) !important;}
.gUkcTr {border-top:1px solid rgb(225 225 225) !important;}
.iYoOhd{background: linear-gradient(166.77deg, rgb(98, 173, 136) 0%, rgb(86, 116, 101) 100%) !important;}
.idoEYB{background: linear-gradient(166.77deg, rgb(98, 173, 136) 0%, rgb(86, 116, 101) 100%) !important;}
.Fllrx{background-color: rgb(0, 169, 78) !important;     color: rgb(255 255 255) !important;}
.jEtSXE{    border: 1px solid rgb(255 255 255) !important;
	background-color: rgb(255 255 255) !important;}
.wAA-Da{ height:auto !important;}
.fjljBh:disabled, .fjljBh.pancake-button--disabled{background-color: rgb(219 219 219) !important;}
.fjljBh{ background-color: rgb(0, 169, 78);}
.gucsmc{ background-color: rgb(0, 169, 78);}
.eJmnNo{border-left:1px solid rgb(170 215 191) !important;}
.dejVqI{border-left:1px solid rgb(170 215 191) !important;}
.cclgbz{border-left:1px solid rgb(170 215 191) !important;}
.cVxDDc {background-color: rgb(244 240 251) !important;}
.iyyzPv{border-top: 2px solid rgb(227 227 227) !important;}
.ehLhbm{background: rgb(255 255 255) !important; padding:20px 0px 40px !important;}
.hvbBFZ{color:#000 !important;}
.zuWPU{border-left: 1px solid rgb(179 225 200) !important;}
.zuWPU{border-left: 1px solid rgb(179 225 200) !important;}
.eoCJKQ{color: #000000 ;}
.bElsxS{fill: rgb(91 191 138) !important;}
.bcnClx{border-left: 1px solid rgb(194 215 204) !important;}
.kpUcGR{border-left: 1px solid rgb(194 215 204) !important;}
.ksobUS{border-left: 1px solid rgb(194 215 204) !important;}
.huZyVy svg{fill: rgb(255 255 255) !important;}
.eWFsXU{color:#000 !important;}
.cWhMwJ{border-bottom: 1px solid rgb(223 223 223) !important;}
.dDpemi{color:#000 !important;}
.cdxWXI{background-color: rgb(238, 234, 244) !important;  border:0px solid rgb(215, 202, 236) !important;}
.llgiyc{border: 1px solid rgb(215, 202, 236) !important;background: rgb(238, 234, 244) !important;}
.jgHLwQ{border: 1px solid rgb(215, 202, 236) !important;background: rgb(238, 234, 244) !important;}
.llgiyc{border: 1px solid rgb(215, 202, 236) !important;background: rgb(238, 234, 244) !important; border-radius: 12px !important;}
.eWHttH{color: rgb(66 65 68) !important;}
.kHAggd{background: rgb(238, 234, 244) !important;}
.fuignW{height: auto !important;}
.eVRXSL{background: rgb(255 255 255) !important; border-bottom: 2px solid rgb(231, 227, 235) !important;}
.gBdoRN{    background: rgb(237 237 237) !important;}
.dsLRqx{    border: 2px solid rgb(211 208 217) !important;}
.gxNRya:disabled, .gxNRya.pancake-button--disabled{background-color: rgb(202 221 210) !important;}
.jaLKwY{fill: rgb(181 181 181) !important;}
.UuThA{background: rgb(255 255 255) !important;     border: 0px solid rgb(56, 50, 65) !important;}
.lerOTr{background-color: rgb(241 241 241) !important;}
.jmDSrG{    background: rgb(255 255 255) !important;}
.ejLpdW{border-bottom: 2px solid rgb(223 223 223) !important;}
.kUzqPM{color: rgb(52 51 51) !important;}
.ckpvCz{color: rgb(52 51 51) !important;}
.ekgJTz{    background: rgb(239 239 239) !important;}
.fJhsGp{background-color: rgb(241 240 243) !important;  border: 1px solid rgb(220 213 235) !important;}
.fRfEkS{background-color: rgb(218 218 231) !important;}
.iEJSQz:disabled, .iEJSQz.pancake-button--disabled{background-color: rgb(204 237 219) !important;}
.ixkYrG{border: 2px solid rgb(213 211 217) !important;}
.lhLgAi{border-top: 2px solid rgb(231 231 231) !important;}
.evSXlY{color: rgb(81 73 106) !important;}
.VJENC{ background-color: rgb(0, 169, 78) !important;}
.jxGpPC{border: 2px solid rgb(0, 169, 78) !important; color: rgb(0, 169, 78) !important;}
.dAYabe{color: rgb(50 48 54) !important;}
.cstboh{color: rgb(89 79 108) !important;}

.dnCwhO {
    color: #000 !important;
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 1.5;
    margin-right: 5px !important;
}
.ihtDzp{background-color: rgb(228 235 234) !important;}
.fWtHcU{color: rgb(33 32 34) !important;}
.hejiRs{color: #000 !important;}
.cdxWXI{border:1px solid rgb(234 233 237) !important; border-radius: 8px !important;}

.swapdiv{background: url(/images/backgrounds/swapbg.jpg) !important; padding:50px 8px;     display: block; background-size: cover !important;}
.cJyzWJ .iLjSLO{max-width: 100% !important; padding-left: 0px !important;  padding-right: 0px !important;}

.swapdiv .col-md-3{background:#fff; padding:28px 15px; border-radius:30px; width:23.2%; float:left; margin-left:20px; text-align: center;    box-shadow: 1px 2px 6px rgb
#00000033 (0 0 0 / 20%);}
.swapdiv .col-md-3 .heading{font-size: 26px !important; color: #000; text-align: center !important; margin-top:8px;}
.swapdiv .subtext{text-align: center !important;     padding: 0px 15px !important;     font-size: 18px !important;}
.mainfooter .subtext {font-size:20px !important; line-height:33px; font-weight: 200 important;}
.moreinfo{background: #00a94e !important; padding: 8px 18px !important;    box-shadow: 1px 1px 5px rgb(0 0 0 / 21%);
    margin-bottom: 5px;}
.moreinfo:hover{cursor: pointer !important; background: #000 !important;}
.whyus .subtext{ font-size: 20px !important;}
.heading .highlight {color: #000 !important; font-size: 66px !important;}
.dsvtkr{max-width: 100% !important; }
.eQIYFA .dsvtkr{padding-left: 0px !important; padding-right: 0px !important;}
.fLKUPX{background-color: rgb(237 237 237) !important;}
.kVNmog{background: rgb(231 231 231) !important;}
.cyfBTY span{color:#fff !important;}
.fvGSig .dsvtkr{padding-left:0px !important; padding-right:0px !important;}
.hWmwoR{color: rgb(255 255 255) !important;}
.mxOZw{max-height: 458px !important;}
.lDjiJ{padding: 12px 0px 40px !important;}

.sc-iGgWBj .clYIXv {
    background: linear-gradient(117.71deg, rgb(0 50 112) 18.76%, rgb(11 77 159) 43.13%, #8f3de9 96.83%) !important;
}
.dtGXiz{background: linear-gradient(rgb(255 255 255) 0%, rgb(255 255 255) 100%) !important;}
.herEdM > div > div:nth-child(2) > div:first-child > div:first-child > div{height: auto !important;}
.herEdM > div > div:nth-child(2) > div:first-child > div:first-child > div div {font-weight:500 !important;}
.ituqiL {padding-left: 24px; padding-right: 24px;}





`

export default GlobalStyle
